import { useState, useEffect } from "react";
import { Col, Form, Input, Row, Select } from "antd";
import "./addProcess.css";
import secureLocalStorage from "react-secure-storage";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";
import { fetchDepartmentsSimpleThunk } from "../../../store/thunks/departmentsThunk";
import { useDispatch } from "react-redux";
import { submitProcessThunk } from "../../../store/thunks/processesThunk";

const { Option } = Select;

const AddProcess = ({ editData, statuses, onSuccess, children }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [departments, setDepartments] = useState([]);
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData);
    const currentDeptId = editData?.department || null;
    const payload = {
      name: values?.name,
      status: isEdit ? values.status : "ACTIVE",
      historySource: "backend",
      historyAction: isEdit ? "update" : "create",
      historyUserID: slsLIUId,
    };

    // Only include department if it has been edited
    if (values.department && values.department !== currentDeptId) {
      payload.department = values.department;
    }
    if (isEdit) {
      payload.id = editData.key;
    }

    await dispatch(submitProcessThunk(payload)).unwrap();
  };

  /**
   * Fetch departments (dropdown)
   */
  const getDepartments = async () => {
    const res = await dispatch(
      fetchDepartmentsSimpleThunk({
        route: "departments",
        action: "findAll",
      })
    ).unwrap();
    const options =
      res?.map((dept) => ({
        label: dept.name,
        value: dept._id,
      })) || [];

    setDepartments(options);
  };

  useEffect(() => {
    if (!editData || departments.length === 0) return;

    const deptValue =
      editData.department?._id ||
      editData.department ||
      editData.department?.[0]?._id ||
      null;

    form.setFieldsValue({
      name: editData.name,
      status: editData.status,
      department: deptValue,
    });
  }, [editData, departments, form]);

  useEffect(() => {
    getDepartments();
  }, []);
  return (
    <AddEditForm
      form={form}
      editData={editData}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      successMessages={{
        create: "Process created successfully",
        update: "Process updated successfully",
      }}
      fields={
        <>
          <Row className="pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                label="Name"
                name="name"
                className="m-0"
                rules={[{ required: true, message: "Please enter the name!" }]}
              >
                <Input placeholder="Enter Process Name" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                label="Department"
                name="department"
                rules={[
                  { required: true, message: "Please select a department!" },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  options={departments}
                  className=""
                  placeholder="Select Department"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            {editData && (
              <Col span={24}>
                <Form.Item
                  label="Status"
                  name="status"
                  className="m-0"
                  rules={[
                    { required: true, message: "Please select a status!" },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    options={statuses}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      }
    />
  );
};
export default AddProcess;
